import React, { useState } from "react";
import ContactForm from "./ContactForm";
function ContactUs() {
 
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: '' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Contact Us</h1>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>Contact Us</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-style01">
        <div className="container">
          <div className="row mt-n1-9">
            <div className="col-lg-7 mt-1-9">
              <div className="border border-color-light-black p-1-9 p-md-5 border-radius-10">
                <div className="section-title01 mb-1-9">
                  <span>Contact Us</span>
                  <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                    Let's get in touch
                  </h2>
                </div>
                <p>
                  Let us know who you are and what you're looking for below, and
                  we'll get back to you within 24 hours.
                </p>

                <ContactForm />
              </div>
            </div>

            {/* Contact Info Right Side */}
            <div className="col-lg-5 mt-1-9">
              <div className="border bg-light border-color-light-black p-1-9 p-md-5 border-radius-10 h-100 d-flex flex-column align-content-around flex-wrap">
                <div className="text-center pb-1-9 pb-lg-2-9 mb-1-9 mb-lg-auto wow fadeInUp" data-wow-delay="100ms">
                  <div className="contact-icon">
                    <i className="fa-solid fa-envelope-open-text"></i>
                  </div>
                  <h3 className="h4">Email Address</h3>
                  <a href="mailto:contactus@shamayitamath.in" className="d-block">contactus@shamayitamath.in</a>
                </div>
                
                <div className="text-center pb-1-9 pb-lg-2-9 mb-1-9 mb-lg-auto wow fadeInUp" data-wow-delay="100ms">
                  <div className="contact-icon">
                    <i className="fa-solid fa-phone-volume"></i>
                  </div>
                  <h3 className="h4">Phone Number</h3>
                  <a href="tel:+919064102591" className="d-block">(+91) 9064102591</a>
                </div>
                
                <div className="text-center wow fadeInUp" data-wow-delay="100ms">
                  <div className="contact-icon">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <h3 className="h4">Shamayita Math Head Office</h3>
                  <p className="mb-0">Ranbahal, Amarkanan, Bankura- 722133.</p>
                  
                  <h3 className="h4 pt-2">Coordination office</h3>
                  <p className="mb-2">● Durgapur (West Bengal) DII/9,4/34,Sarojini Naidu Path, City Centre, Durgapur -16</p>
                  <p className="mb-2">● Jhargram (West Bengal) Shamayita Srotoswini, Kadamkanan, Jhargram, Dist. - West Midnapore</p>
                  <p className="mb-2">● Maa Manasa Apartment,575 S. K. Deb Road, Flat 1C,1st Floor, Kolkata – 700048</p>
                  <p className="mb-2">● Shamayita Math, House no.5, Maansi Sadan, Near Narayan Mandir, District Dakshin Bastar Dantewada, Chhattisgarh – 494449</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-0">
        <iframe
          title="Shamayita Math Location"
          width="100%"
          height="450"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=Shamayita+Math,+Ranbahal,+West+Bengal+722133&output=embed"
        />
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
}

export default ContactUs;
